<template>
  <section>
    <section-header :current="current" />
    <section class="form-section">
      <h5>1. Informações Pessoais</h5>
      <pessoas :current="current" :auto="auto" branch="aluno" @clearEndereco="enderecoData = $event" v-if="ready"/>
    </section>
    <section class="form-section">
      <h5>2. Endereço</h5>
      <endereco :current="current" :auto="auto" v-if="ready" branch="aluno"/>
    </section>
  </section>
</template>

<script>
import SectionHeader from '@/components/matriculas/4/template/SectionHeader.vue'
import Pessoas from '@/components/matriculas/4/form/Pessoas.vue'
import Endereco from '@/components/matriculas/4/form/Endereco.vue'

export default {
  components: {
    SectionHeader, Pessoas, Endereco
  },
  props: {
    current: Object,
    auto: Boolean,
    action: String,
    step: Object
  },
  data () {
    return {
      ready: false,
      matricula: null,
      enderecoData: null
    }
  },
  mounted () {
    this.$store.dispatch('matricula/get').then(response => {
      this.matricula = response
      if ( response.aluno.Basicos.idPessoa ) {  
        this.ready = true
      } else {
        this.get()
      }
      if(this.matricula.idSituacao == 1) {
        this.disabledAll = true
      }

      this.aluno = response.Aluno
    })
  },
  methods: {
    get () {
      this.ready = true
    }
  }
}
</script>

<style lang="scss" scoped>
  h5 {
    margin-bottom: $hmg_mid;
  }

  .form-section {
    margin-bottom: $hmg_mid;
  }
</style>